import { render, staticRenderFns } from "./FiesAditamento.vue?vue&type=template&id=95aef25c&scoped=true&"
import script from "./FiesAditamento.vue?vue&type=script&lang=js&"
export * from "./FiesAditamento.vue?vue&type=script&lang=js&"
import style0 from "./FiesAditamento.vue?vue&type=style&index=0&id=95aef25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aef25c",
  null
  
)

export default component.exports